import * as React from 'react';

import Spacer from 'components/atoms/Spacer';

import type { Notification } from 'components/notification/type';
import NotificationCard from 'components/notification/components/NotificationCard';
import cs from './index.scss';

type Props = {
  notifications: Notification[];
};

const NotificationCardList: React.FC<Props> = React.memo(({ notifications }) => (
  <div>
    {notifications.map((notification) => (
      <div
        className={cs['notification-card-wrapper']}
        key={`${notification.notificationType}-${notification.id}`}
      >
        <Spacer size={16} />
        <NotificationCard
          notification={notification}
          isUnread={false}
          datePosition="left"
        />
        <Spacer size={16} />
      </div>
    ))}
  </div>
));

NotificationCardList.displayName = 'NotificationCardList';

export default NotificationCardList;
